<div class="header">
  <h2>
    {{ "pages.products.title" | translate }}
  </h2>
</div>

<!-- Individueller Vertrag (Migration 081): keine Planauswahl, kein Trial,
     keine Kuendigung im Portal — das Backend sperrt diese Wege ohnehin
     (409 CONTRACT_MANAGED). -->
@if (isContract) {
<nb-card class="contract-notice">
  <nb-card-header>
    <h6><nb-icon icon="credit-card-outline"></nb-icon>{{ "pages.products.contract.title" | translate }}</h6>
  </nb-card-header>
  <nb-card-body>
    <p>{{ "pages.products.contract.message" | translate: { plan: contractName } }}</p>
    <a nbButton status="primary" outline="" [routerLink]="'/organisation'" [queryParams]="{ tab: 'billing' }">
      <span>{{ "pages.products.contract.link" | translate }}</span>
      <nb-icon icon="arrow-forward-outline"></nb-icon>
    </a>
  </nb-card-body>
</nb-card>
} @else {

<!-- Abrechnungszeitraum: ein Schalter statt zweier Buttons. Beide
     Beschriftungen schalten mit, damit die Trefferfläche nicht nur der
     kleine Schalter ist; der aktive Zeitraum ist hervorgehoben. -->
<div class="billing-toggle" role="group" [attr.aria-label]="'pages.products.billing.label' | translate">
  <button
    type="button"
    class="billing-toggle__side"
    [class.is-active]="billingInterval === 'month'"
    [attr.aria-pressed]="billingInterval === 'month'"
    (click)="setBillingInterval('month')"
  >
    {{ "pages.products.billing.monthly" | translate }}
  </button>

  <nb-toggle
    status="primary"
    [checked]="billingInterval === 'year'"
    (checkedChange)="setBillingInterval($event ? 'year' : 'month')"
    [attr.aria-label]="'pages.products.billing.label' | translate"
  ></nb-toggle>

  <button
    type="button"
    class="billing-toggle__side"
    [class.is-active]="billingInterval === 'year'"
    [attr.aria-pressed]="billingInterval === 'year'"
    [nbTooltip]="'pages.products.billing.yearlyTooltip' | translate"
    nbTooltipPlacement="bottom"
    (click)="setBillingInterval('year')"
  >
    {{ "pages.products.billing.yearly" | translate }}
  </button>
</div>

<div class="container" alAnchor="org.plans">
  <app-product-card
    *ngFor="let p of products"
    [product]="p"
    [billingInterval]="billingInterval"
  ></app-product-card>
</div>

<!--  If not free plan -->
@if(activeProduct?.id !== 'ed738dc0-483a-4d1e-a779-b7fb29f8c5b0'){
@if(authService.hasAccess(authService.UserAccess.OrganisationManageSubscription)){
<div class="cancel">
  <button
    size="giant"
    nbButton
    status="danger"
    outline=""
    (click)="cancelSubscription()"
  >
    <span>{{ "buttons.cancelSubscription" | translate }}</span>
    <nb-icon icon="backspace-outline"></nb-icon>
  </button>
</div>
} }
}
